import { pgTable, uuid, text, timestamp } from "drizzle-orm/pg-core";

// Internal newsletter signup store (owner 2026-09-25). The active ESP
// (Brevo — parked — or Resend later) is a downstream mirror; this table is
// the source of truth the panelis lists.
export const newsletterSubscribers = pgTable("newsletter_subscribers", {
  id: uuid("id").primaryKey().defaultRandom(),
  email: text("email").notNull().unique(),
  firstName: text("first_name"),
  locale: text("locale"),
  source: text("source").notNull().default("storefront"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  unsubscribedAt: timestamp("unsubscribed_at", { withTimezone: true }),
});

export type NewsletterSubscriber = typeof newsletterSubscribers.$inferSelect;
